// Scroll in animation logic from animation.js file
const observer = new IntersectionObserver(onCountupIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });

  document.addEventListener('DOMContentLoaded', function() {
    const elementToObserve = document.querySelector('.countup-text');
    observer.observe(elementToObserve);
  });

  function onCountupIntersection(entries, observer) {
    entries.forEach((entry, index) => {
        if (entry.isIntersecting) {
            const element = entry.target;
            //  Element is now in the viewport
            countupFromText(element)
            // ------------

            observer.unobserve(entry.target);  //  Stop observing the element after it has been animated
        }
    });
  }
  //  ------------


function countupFromText(elem) {
    const strippedCommas = elem.dataset.target.replace(/,/g, '');
    const target = (strippedCommas !== undefined ) ? Number(strippedCommas) : elem.dataset.target;
    if (isNaN(target) || target <= 0 ) return; // Exit if target is not a number or not a positive number
    const animationDuration = Number(elem.dataset.durationMs);
    if (isNaN(animationDuration)) return; // Exit if duration is not a number
    const countspeed = 50; // A recommended interval for smooth and comfortable animation
    const step = target / (animationDuration / countspeed);
    let count = 0;
    
    const interval = setInterval(() => {
        if (count < target) {
            count = Math.min(count + step, target);
            const dp = decimalPlace(target);
            const output = count.toLocaleString('en-US', {
              minimumFractionDigits: dp,
              maximumFractionDigits: dp
            });
            elem.querySelector('.js-count').innerText = output;
        } else {
            clearInterval(interval);
        }
    }, countspeed);
  }

  function decimalPlace(num) {
    const str = num.toString();
    if (!str.includes('.')) return 0;
    return str.split('.')[1].length;
  }